<template>
  <v-card>
    <v-list
      v-if="needsMenu"
      class="sn-table-column-menu"
      subheader
    >
      <template
        v-if="showSort"
      >
        <v-subheader class="sn-subtitle-2 sn-table-filter-subheader">
          SORT
        </v-subheader>
        <v-list-item-group
          v-model="selectedSort"
        >
          <v-list-item
            v-for="sort in header.sortBy"
            :key="sort.value"
            :value="sort.value"
            :ripple="false"
            class="sn-table-filter-menu-item"
          >
            <template v-slot:default="{ active }">
              <v-list-item-action class="mr-3">
                <v-icon
                  color="snBrand03"
                  v-text="active ? '$snRadioSelected' : '$snRadio'"
                />
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title
                  class="sn-body-1"
                  color="snBrand03"
                >
                  {{ sort.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </v-list-item-group>
      </template>

      <template v-if="showFilters">
        <v-subheader class="sn-subtitle-2 sn-table-filter-subheader">
          FILTER
        </v-subheader>
        <v-list-item-group
          v-model="selectedFilters"
          multiple
        >
          <v-list-item
            v-for="filter in header.filterBy"
            :key="filter.value"
            :value="filter.value"
            :ripple="false"
            class="sn-table-filter-menu-item"
          >
            <template v-slot:default="{ active }">
              <v-list-item-action class="mr-3">
                <v-icon
                  color="snBrand03"
                  v-text="active ? '$snCheckBoxSelected' : '$snCheckBox'"
                />
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title
                  class="sn-body-1"
                  color="snBrand03"
                >
                  {{ filter.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </v-list-item-group>
      </template>
    </v-list>
    <v-card-actions class="pa-0">
      <v-spacer />
      <sn-btn
        v-if="needsMenu"
        size="standard"
        text="Apply"
        class="sn-table-column-menu-btn"
        @click="applyChanges"
      />
    </v-card-actions>
  </v-card>
</template>

<script>

import SnBtn from '~/components/snui/v2/snBtn/snBtn'
import snTableFilterMixin from './snTableFilterMixin'

export default {
  name: 'SnTableFilterMenu',
  components: {
    SnBtn
  },
  mixins: [snTableFilterMixin],
  props: {
    hideSort: {
      type: Boolean,
      required: false,
      default: false
    },
    hideFilters: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      selectedSort: null,
      selectedFilters: null,
      menuOpen: false
    }
  },
  computed: {
    showSort () {
      return this.header.sortBy && !this.hideSort
    },
    showFilters () {
      return this.header.filterBy && !this.hideFilters
    },
    needsMenu () {
      return this.showSort || this.showFilters
    }
  },
  watch: {
    activeSort: {
      handler (val) {
        this.selectedSort = val
      },
      immediate: true
    },
    activeFilters: {
      handler (val) {
        this.selectedFilters = val
      },
      immediate: true
    }
  },
  methods: {
    applyChanges () {
      this.$emit('change', { activeSort: this.selectedSort, activeFilters: this.selectedFilters })
    }
  }
}

</script>
<style lang="scss" scoped>
@import '~/assets/css/snui';

.sn-table-column-menu-btn {
  float: right;
  margin: 15px;
}

.sn-table-column-menu {
  min-width: 250px;
}

.sn-table-filter-menu-item {
  color: transparent !important;
}

</style>
